import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import type { BulkOverrideForm } from './bulkFulfillmentOverride';
import { effectiveQuantity } from './lineQuantity';

/** Quantity to send for one line in a bulk plan/vendor override. */
export function bulkQuantityForLine(
  line: AssignmentLine,
  form: BulkOverrideForm,
): number {
  if (form.applyQuantityToAllLines) {
    return form.quantity;
  }
  return effectiveQuantity(line);
}
